import React from "react";
import {Redirect} from "react-router-dom";

export default class Login extends React.Component {

    state = {
        sourceUrl: this.props.sourceUrl,
        authenticated: "FALSE"
    }



    authentication() {

        this.setState({authenticated: "PENDING"})
    }

    render() {

        let queryString = '?SessionId=0dasd4gf42f&Userid=USER_ID&UserName=USER_NAME&UserSurname=USER_SURNAME&UserRoles=Operatore_UI&UserRoles=Responsabile_UI&ApplicationId=APPLICATION_ID'

        return <>
            {this.state.authenticated === "FALSE" && <div style={{textAlign: "center"}}>
                <button className="btn btn-primary" onClick={() => this.authentication()}>Autenticati</button>
            </div>}
            {this.state.authenticated === "PENDING" &&
            (
                <Redirect to={{
                    pathname: "/auth",
                    state: {sourceUrl: this.props.sourceUrl},
                    search: queryString
                }}/>)
            }
        </>
    }
}
